var map = {
	"./100.svg": 91410,
	"./404_1.svg": 33419,
	"./404_2.svg": 99032,
	"./android.svg": 34806,
	"./baidu.svg": 16998,
	"./bili.svg": 43335,
	"./bozhu.svg": 22771,
	"./chat.svg": 56839,
	"./chrome.svg": 99783,
	"./copyright.svg": 35848,
	"./csdn.svg": 82825,
	"./deep.svg": 61959,
	"./dianzan.svg": 18160,
	"./edge.svg": 10522,
	"./email.svg": 39083,
	"./emoji1.svg": 91198,
	"./emoji2.svg": 19645,
	"./gitee.svg": 84041,
	"./github.svg": 60200,
	"./google.svg": 15060,
	"./guanfang.svg": 34866,
	"./guanzhume.svg": 18661,
	"./hot.svg": 51542,
	"./link.svg": 81445,
	"./mac.svg": 25570,
	"./notice.svg": 89881,
	"./photo.svg": 36743,
	"./qq.svg": 75951,
	"./qqgroup.svg": 76604,
	"./safari.svg": 34353,
	"./shallow.svg": 60491,
	"./shandian.svg": 7181,
	"./sxdianzan.svg": 31799,
	"./tag.svg": 1163,
	"./topBar.svg": 99081,
	"./tuijian.svg": 79699,
	"./wechat.svg": 80719,
	"./weibo.svg": 14003,
	"./windowns.svg": 76228,
	"./xkxy.svg": 58331,
	"./xuhao.svg": 99784,
	"./yuan.svg": 30102,
	"./yuanchuang.svg": 33308,
	"./zhihu.svg": 50229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;